import { useQuery } from "@tanstack/react-query";

import type { PaymentSource } from "features/payment-methods/types";

import { CUSTOMER_QUERY_KEYS } from "common/constants";
import { get } from "common/helpers/HTTP";

async function getPaymentSourcesRequest() {
  return (await get("billing/payment-sources")).payment_sources;
}

export default function usePaymentSources() {
  const { data: paymentSources, isLoading: isLoadingPaymentSources } = useQuery<
    PaymentSource[]
  >({
    queryKey: CUSTOMER_QUERY_KEYS.paymentSourceKeys.list(),
    queryFn: getPaymentSourcesRequest,
  });

  return {
    paymentSources,
    isLoadingPaymentSources,
  };
}
